const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaGranja: [], listaLocal: [], listaAnimal: [], listaItens: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'TRANSFERENCIA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'TRANSFERENCIA_LISTADO':
            return { ...state, lista: action.payload.data };
		case 'TRANSFERENCIA_ITEM_LISTADO':
			return { ...state, listaItens: action.payload.data };
		case 'TRANSFERENCIA_GRANJA_SELECT_LISTADO':
            return { ...state, listaGranja: action.payload.data };
		case 'TRANSFERENCIA_LOCAL_SELECT_LISTADO':
            return { ...state, listaLocal: action.payload.data };
		case 'TRANSFERENCIA_ANIMAL_SELECT_LISTADO':
            return { ...state, listaAnimal: action.payload.data };
		default:
            return state;
    }
}
